
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 0C5.832 0 0 5.1 0 11.368c0 2.192.713 4.314 2.066 6.15-.256 2.752-.942 4.795-1.939 5.763a.412.412 0 00-.081.486.434.434 0 00.448.229c.175-.024 4.252-.594 7.2-2.248 1.675.656 3.459.989 5.306.989 7.168 0 13-5.1 13-11.369C26 5.1 20.168 0 13 0zM6.933 13.053c-.956 0-1.733-.756-1.733-1.685 0-.928.777-1.684 1.733-1.684.956 0 1.734.756 1.734 1.684 0 .93-.778 1.685-1.734 1.685zm6.067 0c-.956 0-1.733-.756-1.733-1.685 0-.928.777-1.684 1.733-1.684.956 0 1.733.756 1.733 1.684 0 .93-.777 1.685-1.733 1.685zm6.067 0c-.956 0-1.734-.756-1.734-1.685 0-.928.778-1.684 1.734-1.684s1.733.756 1.733 1.684c0 .93-.777 1.685-1.733 1.685z"}})])
          )
        }
      }
    